import React, { FC } from 'react';
import { TExpandableOverlayCarouselPopUpArrow } from '../../types/overlayCarouselPopup.types';
import { iconSize } from '../../../../../constants/icon.constants';
import Icon from '../../../icon';

const OverlayCarouselArrow: FC<TExpandableOverlayCarouselPopUpArrow> = ({ direction, onClick, customClass = '' }) => {
  const icon =  (direction === 'previous' ? 'arrow-chevron-left' : 'arrow-chevron-right');

  return (
    <button
      className={`overlay-carousel-popup__arrow-control
        overlay-carousel-popup__arrow-control--${direction}
        ${customClass}`}
      aria-label={direction + 'slide / item'}
      onClick={onClick}
    >
      <Icon iconName={icon} extraClassName='overlay-carousel-popup__arrow-icons' size={iconSize.dsk} />
    </button>
  );
};

export default OverlayCarouselArrow;
